// Llaves de sesión de Supabase en localStorage, UNA POR ENTRADA.
// La interna (index.html) y el portal (portal.html) viven en el mismo origen: con la llave por omisión
// (`sb-<proyecto>-auth-token`) compartían la sesión, y entrar al portal como usuaria de un cliente dejaba la
// interna vacía (la RLS la bloqueaba). Con llaves distintas, las dos sesiones conviven.
// «Ver como el cliente» (portal.html?ver_como=…) es la interna mirando el portal: usa la sesión de la interna.
export const CLAVE_SESION_INTERNA = "sb-interna";
export const CLAVE_SESION_PORTAL = "sb-portal";
